<template>
    <div class="form-login content-div " id="content1">
        <form>
            <div class="mb-3">
                <h3>Vous n'êtes pas connecté</h3>
            </div>
            <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">Email address</label>
                <input v-model="email" type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Adresse mail">
                <!-- <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div> -->
            </div>
            <p class="help is-danger">{{email_error}}</p>
            <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">Mot de passe</label>
                <input v-model="password" type="password" class="form-control" id="exampleInputPassword1" placeholder="Mot de passe">
            </div>
            <p class="help is-danger">{{password_error}}</p>
            <div class="mb-3 form-check">
                <h6 class="">Mot de passe oublié ? <a @click="$emit('forgottenPassword')" href="#">Cliquez ici</a></h6>
            </div>
            <div class="login-disp">
                <button type="button" class="btn-primary1" @click="tryLogin">Me connecter</button>
                <button type="button" class="btn-secondary1" @click="$emit('signUp',true)">Je m’inscris</button>

            </div>
        </form>
    </div>    
</template>

<script>
import { Inertia } from '@inertiajs/inertia';
import axios from 'axios';
import { toast } from 'bulma-toast';

export default {
    name: 'SignIn',
    emits: ['userLogin','forgottenPassword','signUp'],
    data () {
        return {
            email: null,
            email_error: null,
            form_error: null,
            password: null,
            password_error: null
        }
    },
    methods : {
        toggleModal () {
            let modal = document.querySelector('#auth-modal')
            modal.classList.toggle('is-active')
        },
        tryLogin () {
            if (!this.email || !this.email.trim()) {
                this.email_error = "Merci de renseigner l'adresse mail."
                return false
            }
            const mail_reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!mail_reg.test(String(this.email).toLowerCase())) {
                this.email_error = "L'adresse mail est incorrecte."
                return false
            }
            this.email_error = null
            if (!this.password || !this.password.trim()) {
                this.password_error = "Le mot de passe est requis"
                return false
            }
            this.password_error = null
            axios.post('/auth/login', {
                email: this.email,
                password: this.password
            })
            .then(response => {
                this.form_error = null
                let user = response.data.client
                console.log('user login')
                this.$emit('userLogin', user)
                // this.toggleModal()
                Inertia.reload({ only: ['auth.user'] })
                // console.log('user',this.user);
            })
            .catch(error => {
                let message = '';
                switch (error.response.status) {
                    case 403:
                        message = 'mail ou mot de passe incorrect';
                        break;

                    case 500:
                        message = 'Une erreur est survenue lors du traitement';
                        break;                
                
                    default:
                        break;
                }
                toast({
                    message: message,
                    type: "is-danger",
                    duration: 5000,
                    pauseOnHover: true,
                });
            })
        }
    }
}
</script>

<style scoped>
    #btn-signin {
        background-color: var(--btn-primary-bg-color);
        color: var(--btn-primary-text-color);
    }

    #btn-signin:hover {
        background-color: var(--btn-primary-bg-color-hover);
        color: var(--btn-primary-text-color);
    }

    #btn-signup {
        background-color: var(--btn-secondary-bg-color);
        color: var(--btn-secondary-text-color);
    }

    #btn-signup:hover {
        background-color: var(--btn-secondary-bg-color-hover);
        color: var(--btn-secondary-text-color);
    }
</style>
